import { Component } from '@angular/core';

@Component({
    selector: 'app-external-user-account',
    templateUrl: './external-user-account.component.html',
    styleUrl: './external-user-account.component.scss',
    standalone: false
})
export class ExternalUserAccountComponent {

}
